export default __webpack_public_path__ + "static/media/sticker-6.5506ad2f.png";